import {forwardRef, ReactNode} from 'react'
import {variant} from 'styled-system'
import styled from '@emotion/styled'

import {buttonBaseCss, ButtonVariant, buttonVariants} from 'src/styles/button'
import Loading from 'src/components/Loading'

interface CommonProps {
  disabled?: boolean
  variant?: ButtonVariant
  children: ReactNode
  busy?: boolean
}

interface ButtonType extends CommonProps {
  onClick: () => void
  type?: 'button'
}

interface FormButtonType extends CommonProps {
  type: 'submit' | 'reset'
  onClick?: undefined
}

type Props = ButtonType | FormButtonType

const StyledButton = styled.button<{variant: ButtonVariant}>(
  buttonBaseCss,
  variant({
    variants: buttonVariants,
  })
)

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      type = 'button',
      disabled = false,
      variant = 'primary',
      busy = false,
      ...rest
    },
    ref
  ) => (
    <StyledButton
      ref={ref}
      variant={busy || disabled ? 'disabled' : variant}
      disabled={busy || disabled}
      type={type}
      {...rest}
    >
      {busy ? <Loading size="small" /> : children}
    </StyledButton>
  )
)

export default Button
